export default __webpack_public_path__ + "static/investree_logo-0a97a37640032063b479017a2c16af8b.png";